import { ComponentType } from '@angular/cdk/portal';
import { inject, Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class ModalService {
  dialog = inject(MatDialog);

  openList<T, R = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>): MatDialogRef<T, R> {
    return this.dialog.open(componentOrTemplateRef, {
      width: '800px',
      height: '90dvh',
      maxWidth: '100vw',
      maxHeight: '100dvh',
      autoFocus: false,
    });
  }

  openInformational<T, R = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>): MatDialogRef<T, R> {
    return this.dialog.open(componentOrTemplateRef, {
      width: '800px',
      maxWidth: '100vw',
      maxHeight: '100dvh',
      autoFocus: false,
    });
  }

  openFullscreen<T, R = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>): MatDialogRef<T, R> {
    return this.dialog.open(componentOrTemplateRef, {
      width: '100vw',
      height: '100dvh',
      maxWidth: '100vw',
      maxHeight: '100dvh',
      autoFocus: false,
    });
  }
}
